import React, { useState, useEffect } from "react"
import Truncate from "react-truncate"
import Img, { FluidObject } from "gatsby-image"
import { EventData } from "react-swipeable/types"

interface Props {
  quote?: string
  author: string
  role: string
  logoSrc?: FluidObject
  logoAltText?: string
}

export default function Testimonial(props: Props) {
  const [isToggled, setIsToggled] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  function toggleLines(e: React.MouseEvent) {
    e.preventDefault()
    if (isToggled) setIsToggled(false)
    if (!isToggled) setIsToggled(true)
  }

  function handleTruncated(truncated: boolean) {
    if (isTruncated !== truncated) {
      setIsTruncated(truncated)
    }
  }

  const { quote, author, role, logoSrc } = props
  return quote ? (
    <div className="w-full p-3 rounded-lg bg-lightGrey">
      <div className="mb-2 text-16 leading-p text-darkGrey italic tracking-9">
        <Truncate
          lines={!isToggled && 3}
          ellipsis={
            <span>
              ...{" "}
              <a href="#" className="text-16 leading-p text-body tracking-9" onClick={toggleLines}>
                Read more
              </a>
            </span>
          }
          className="preserve-lines-util"
          onTruncate={handleTruncated}
        >
          {quote}
        </Truncate>
        {!isTruncated && isToggled && (
          <span>
            {" "}
            <a href="#" className="text-16 leading-p text-body tracking-9" onClick={toggleLines}>
              See less
            </a>
          </span>
        )}
      </div>
      <div className="flex">
        <div className="mr-1.5 w-5.5 h-5.5">
          {logoSrc && <Img fluid={logoSrc} className="min-w-5.5 h-auto rounded-full" alt="logo" />}
        </div>
        <div className="h-full">
          <p>{author}</p>
          <p className="font-black">{role}</p>
        </div>
      </div>
    </div>
  ) : null
}
